import { Controller } from "stimulus"
import { formatMoney, formatMoneyMillis, formatWeight } from 'formatters';

export default class extends Controller {
  static values = { type: String, id: String, select: String }
  
  setTypeField(event) {
    var idField = $(this.element).find(this.idValue);
    var typeField = $(this.element).find(this.typeValue);
    var typeOption = idField.find("option:selected");
    typeField.val(typeOption.data('type'));
  }

  setTypeAndIdField(event) {
    var selectField = $(this.element).find(this.selectValue);
    var idField = $(this.element).find(this.idValue);
    var typeField = $(this.element).find(this.typeValue);
    var selectedOption = selectField.find("option:selected");
    typeField.val(selectedOption.data('type'));
    idField.val(selectedOption.data('id'));
  }
}
